import { GetSeatmapsResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetSeatmapsModel } from './get-seatmaps.state';

/** StateDetailsActions */
const ACTION_SET = '[GetSeatmaps] set';
const ACTION_UPDATE = '[GetSeatmaps] update';
const ACTION_RESET = '[GetSeatmaps] reset';
const ACTION_FAIL = '[GetSeatmaps] fail';
const ACTION_CANCEL_REQUEST = '[GetSeatmaps] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetSeatmaps] set from api';
const ACTION_UPDATE_FROM_API = '[GetSeatmaps] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetSeatmaps = createAction(ACTION_SET, props<WithRequestId<GetSeatmapsModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetSeatmaps = createAction(ACTION_UPDATE, props<WithRequestId<Partial<GetSeatmapsModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetSeatmaps = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetSeatmapsRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetSeatmaps = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetSeatmapsFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetSeatmapsResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetSeatmapsFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetSeatmapsResponse>>()
);
